import axiosInstance from "../api/axiosInstance";
// GET list with pagination and search
export const fetchBooking = (params) => axiosInstance.get("/admin/bookingList", { params });
// Get By ID
export const bookingDetail = (id) => axiosInstance.get(`/admin/bookingDetail/${id}`);
